import { useEffect } from 'react';

import { SNOWPLOW_TRIGGER } from 'Utilities/analytics';

import {
  OptimizelyScript,
  useAgentAvailability,
  useBroadcast,
  useCognito,
  useCookieCheck,
  useGA,
  useOptimizely,
  useSnowplow,
  useUTM,
} from './initHooks';

const initHooks = [
  useAgentAvailability,
  useBroadcast,
  useCookieCheck,
  useGA,
  useOptimizely,
  useSnowplow,
  useUTM,
  useCognito,
  // Needs to be the last hook
  () => useEffect(() => {
    SNOWPLOW_TRIGGER('trackPageView');
  }, []),
]
  .map((hook) => () => {
    hook();
    return null;
  })
  .map((Hook, index) => (
    <Hook key={index} />
  ));

export const Init = () => (
  <>
    {initHooks}
    <OptimizelyScript />
  </>
);
